import React from 'react';
import { PropTypes } from 'prop-types';

import { AppContentInner, AppContentTitle } from '../../styles';
import RecordsListTable from '../../components/custom/RecordsListTable';

function RecordsList({ location: { search } }) {
  const params = new URLSearchParams(search);
  const preSettlementRequestId = params.get('preSettlementRequestId');

  return (
    <AppContentInner>
      <AppContentTitle>Records List</AppContentTitle>
      <RecordsListTable requestId={preSettlementRequestId} />
    </AppContentInner>
  );
}

RecordsList.propTypes = {
  location: PropTypes.shape(),
};

export default RecordsList;
